import { BaseImageProps, IMAGE_PRESETS } from './types';

/**
 * Creates props for overview images (small thumbnails in lists/grids)
 */
export function createOverviewImageProps(overrides: Partial<BaseImageProps>): BaseImageProps {
  return {
    ...IMAGE_PRESETS.overview,
    ...overrides,
  };
}

/**
 * Creates props for detail images (larger images on detail pages)
 */
export function createDetailImageProps(overrides: Partial<BaseImageProps>): BaseImageProps {
  return {
    ...IMAGE_PRESETS.detail,
    ...overrides,
  };
}

/**
 * Creates props for avatar images (circular profile pictures)
 */
export function createAvatarImageProps(
  overrides: Partial<BaseImageProps>,
  width = 40,
): BaseImageProps {
  return {
    width,
    mobileWidth: width,
    desktopWidth: width,
    aspectRatio: 1,
    rounded: 'circle',
    cover: true,
    generateSrcset: true,
    ...overrides,
  };
}
